import { Box } from '@material-ui/core';
import '../styles/loadingState.css';

interface ThreeDotIndicatorProps {
  className?: string;
}

// Staggered pulsing dots signaling "agent is working, no events yet".
export default function ThreeDotIndicator({
  className,
}: ThreeDotIndicatorProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      className={className}
    >
      <span className="ec-three-dot ec-three-dot-1" />
      <span className="ec-three-dot ec-three-dot-2" />
      <span className="ec-three-dot ec-three-dot-3" />
    </Box>
  );
}
